import React from "react";
import { LoadPanel } from "devextreme-react/load-panel";

const ContinuousLoadingComponent = () => {
  return <LoadPanel visible={true} showIndicator={true} />;
};

export default ContinuousLoadingComponent;
